import Conclave from '../components/conclave';

export default function Safetyconclave() {
  return(
    <Conclave geturl={'https://cpccbe.org/api/safetyconclave/allmodals'} 
    createmodel1url={'https://cpccbe.org/api/safetyconclave/modal1'}
    createmodel2url={'https://cpccbe.org/api/safetyconclave/modal2'}
    updateurl={'https://cpccbe.org/api/safetyconclave/modal'}
    deleteurl={'https://cpccbe.org/api/safetyconclave/modal'}
    head={'Safety Conclave'}
    />
  );
}